import React from "react";

import ContainerBleed from "@app/components/ContainerBleed";

import styles from "./YoutubeVideo.module.css";

export default function YoutubeVideo({ children, src, ...rest }) {
  return (
    <ContainerBleed {...rest}>
      <div className={styles.content}>
        <div className={styles.margin}>
          <iframe
            className={styles.video}
            src={src}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </ContainerBleed>
  );
}
